<template>
  <div v-if="visible" id="job-actions-store">
    <div v-if="type === 'requirements'">
      <el-dialog
        v-model="visible"
        title="Les Indispensables"
        width="50%"
      >
        <template v-if="requirements">
          <p v-for="(req, idx) in requirements" :key="idx">
            - {{ req }}
          </p>
        </template>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="close">OK</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useJobActionsStore } from '@/stores/jobActions';

export default {
  computed: {
    ...mapStores(useJobActionsStore),
    visible: {
      get() {
        return this.jobActionsStore.visible;
      },
      set() {
        this.jobActionsStore.close();
      },
    },
    type() {
      return this.jobActionsStore.type;
    },
    requirements() {
      return this.jobActionsStore.requirements;
    },
  },
  methods: {
    close() {
      this.jobActionsStore.close();
    },
  },
};
</script>
